module.exports = __webpack_public_path__ + "img/subscription.6ddfe914.png";